import { Link } from 'react-router-dom';
import LogoSquare from '../components/logo-square';
import { XCircle } from 'lucide-react';

export default function CheckoutFailedPage() {
  return (
    <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900 flex flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-md text-center">
        <Link to="/" className="inline-block mb-8">
          <LogoSquare />
        </Link>
        <div className="rounded-2xl border border-neutral-200 bg-white p-8 shadow-sm dark:border-neutral-700 dark:bg-neutral-800">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/30">
            <XCircle className="h-10 w-10 text-red-600 dark:text-red-400" />
          </div>
          <h1 className="mb-2 text-xl font-semibold text-neutral-900 dark:text-white">
            Paiement annulé ou échoué
          </h1>
          <p className="mb-6 text-sm text-neutral-600 dark:text-neutral-400">
            Votre paiement n’a pas abouti. Vous pouvez réessayer ou modifier votre panier.
          </p>
          <div className="flex flex-col gap-3">
            <Link
              to="/"
              className="inline-block w-full rounded-full bg-gradient-to-r from-[#ff0442] to-[#ff1a4d] px-6 py-3 text-center text-sm font-medium text-white hover:opacity-95"
            >
              Retour à l’accueil
            </Link>
            <Link
              to="/checkout"
              className="inline-block w-full rounded-full border-2 border-neutral-300 px-6 py-3 text-center text-sm font-medium text-neutral-700 hover:bg-neutral-100 dark:border-neutral-600 dark:text-neutral-300 dark:hover:bg-neutral-700"
            >
              Voir mon panier
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
